/** The number of miliseconds since 1st January 1970 */
export type Timestamp = number;
